import { useEffect, useState } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { useUser } from '../../context/UserContext';
import { recapturaBitacora } from '../../api/apiConfig';
import { unwrap } from './recapturaUtils';

const RecapturaBitacora = () => {
  const { user } = useUser();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const resp = unwrap(await recapturaBitacora(user, { limit: 200 }));
        if (cancelled) return;
        if (resp.ok === false) throw new Error(resp.error || 'Error');
        setRows(resp.data || []);
      } catch (e) {
        if (!cancelled) setError(e.message || 'No se pudo cargar bitácora');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [user]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-1">Activación Comercial — Bitácora y cierres</h1>
      <p className="text-sm text-gray-600 mb-4">Trazabilidad de contactos, propuestas, decisiones y eventos.</p>

      {loading && (
        <div className="flex items-center gap-2 text-gray-600">
          <AiOutlineLoading3Quarters className="animate-spin" /> Cargando…
        </div>
      )}
      {error && <div className="p-3 bg-red-50 text-red-700 rounded-lg text-sm">{error}</div>}

      {!loading && !error && (
        <div className="seccion-datos">
          <div className="border-l-2 border-slate-200 pl-4 space-y-4">
            {rows.length === 0 && <p className="text-sm text-gray-500 italic">Sin eventos.</p>}
            {rows.map((e, i) => (
              <div key={i}>
                <div className="font-semibold text-sm">{e.fecha} · {e.cliente || e.rut}</div>
                <div className="text-xs text-gray-500">{e.actor} · {e.tipo} · {e.ejecutivo || ''}</div>
                <p className="text-sm mt-1">{e.detalle}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RecapturaBitacora;
